module.exports = __webpack_public_path__ + "5f2872fa62d59a0d687e2c65f9af86e6.pdf";